import React from "react";
import { Row, Column } from "react-foundation";

import ThemeButton from "./../../components/ThemeButton";

import Logo from "components/Logo";

const Thanks = () => {
    return (
        <div style={{ position: "relative" }}>
            <Logo topLeft={true} />
            <Row className="top-padding-page">
                <Column small={10} medium={8} large={6} centerOnSmall>
                    <h3>Thank You</h3>
                    <p>We’re in the process of generating your quotes. Please bear with us and expect an email in the next 5 minutes.</p>
                </Column>
            </Row>
            <ThemeButton className="button" onClick={() => (window.location = "/")}>
                Start Again
            </ThemeButton>
        </div>
    );
};

export default Thanks;



// WEBPACK FOOTER //
// ./src/containers/QuoteForm/Thanks.js